import Vue from 'vue'
// eslint-disable-next-line import/named
import { permissionDirective } from './permission-directive'
Vue.directive('isAllowed', permissionDirective)
